export function simpleTransformer(response: Response): any {
  return response
}
